
const baseURL = 'https://staging.smudg.co/api/partner'
// const baseURL = 'http://192.168.1.5:8000/api/partner'

export const SERVER_URL = {
    REGISTER: baseURL + '/register-user',
    RECOMMENDATIONS: baseURL + '/recommendations'
}